<template>
  <div class="container_box details_box_styles">
    <!--金刚区-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005045') }}</h2>
        </template>
        <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <Form class="vajraDistrict_box" :label-width="130" @submit.native.prevent>
                <Row class="vajraDistrict_item" v-for="(ele,index) in vajraDistrictList" :key="index">
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label="labelNameRander(item,index)" :prop="'name_' + item.code" :class="item.code === 'zh-CN' ?'required_style_label' : ''">
                      <Input v-model.trim="ele['name_' + item.code]" clearable :placeholder="$t('key1005040')"></Input>
                    </Form-item>
                  </Col>
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <FormItem :label="$t('key1005041')" :class="item.code === 'zh-CN' ?'required_style_label' : ''">
                      <Upload
                        ref="upload"
                        type="drag"
                        name="files"
                        :headers="headObj"
                        :action="fileApi"
                        :data="uploadData"
                        :show-upload-list="false"
                        :on-success="(value) => handelUploadSuccess(value, item, index)"
                        :format="['jpg', 'jpeg', 'png', 'gif', 'bmp']"
                        :max-size="20480"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize">
                        <div class="img_style" v-if="ele['imagePath_' + item.code]">
                          <img style="width: 80%; height: auto; display: inline-block" :src="setImgPath(ele['imagePath_' + item.code])" alt=""/>
                        </div>
                        <div v-else>
                          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                          <p class="upload_txt">
                            <span>{{ $t('key1005046') }}</span>
                            <span class="tips_txt">{{ $t('key1005047') }}</span>
                          </p>
                        </div>
                      </Upload>
                    </FormItem>
                  </Col>
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label="$t('key1005042')" class="required_style_label">
                      <div class="jump_box">
                        <span class="jump_text" v-if="ele.jumpTargetName" :title="ele.jumpTargetName">{{ ele.jumpTargetName }}</span>
                        <span class="not_filled_text" v-else>{{ $t('key1005048') }}</span>
                        <Button type="primary" size="small" @click="replaceBtn(ele, index)">
                          {{ ele.jumpTargetName ? $t('key1005043') : $t('key1000669') }}
                        </Button>
                      </div>
                    </Form-item>
                  </Col>
                </Row>
              </Form>
            </template>
          </template>
        </languagesTabs>
      </Card>
    </div>
    <!--效果预览-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005049') }}</h2>
        </template>
        <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <div class="vajraDistrict_effect_box">
                <div class="vajraDistrict_effect_item" v-for="(ele, index) in vajraDistrictList" :key="index">
                  <img class="banner_img" v-if="ele['imagePath_' + item.code]" :src="setImgPath(ele['imagePath_' + item.code])" @error="setErrorImg($event)"/>
                  <div v-else class="design_sketch_styles"> {{ $t('key1005044') + (index + 1) }}</div>
                  <h3 class="title" :title="ele['name_' + item.code]">{{ ele['name_' + item.code] }}</h3>
                </div>
              </div>
            </template>
          </template>
        </languagesTabs>
      </Card>
    </div>
    <!--底部操作按钮-->
    <div class="options_content">
      <Button class="mr15" @click="rotationChartCancelBtn">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" v-if="getPermission('ymsAdvertisement_save') || getPermission('ymsAdvertisement_update')"
        @click="rotationChartBtn">{{ $t('key1000555') }}</Button>
    </div>
    <!--更换活动弹窗设置-->
    <clickJumpModal ref="clickJump" @updateData="updateData"></clickJumpModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import clickJumpModal from "@/views/yms/components/marketingManage/clickJumpModal";
import languagesTabs from "@/components/common/languagesTabs.vue";

export default {
  name: "vajraDistrict",
  mixins: [Mixin],
  data() {
    return {
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      vajraDistrictList: [
        {jumpTargetType: null, jumpTargetValue: '', jumpTargetName: ''},
        {jumpTargetType: null, jumpTargetValue: '', jumpTargetName: ''},
        {jumpTargetType: null, jumpTargetValue: '', jumpTargetName: ''},
        {jumpTargetType: null, jumpTargetValue: '', jumpTargetName: ''},
        {jumpTargetType: null, jumpTargetValue: '', jumpTargetName: ''}
      ],
      currentIndex: null,
      ymsAdvertisementId: null,
      labelNameRander: (params, index) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005032') + (index + 1) + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      advertisementTitle: '',
    };
  },
  created() {
    this.systemDefaultLanguage().then(() => {
      this.initMultilingualFields();
    });
    this.ymsAdvertisementId = this.$route.query.ymsAdvertisementId || null;
    if (this.ymsAdvertisementId) {
      this.getDetailsData();
    }
  },
  methods: {
    // 初始化多语种图片的数据字段
    initMultilingualFields() {
      if (this.multilingualNamesList.length > 0) {
        this.multilingualNamesList.map((item) => {
          this.vajraDistrictList.map((ele) => {
            ele['name_' + item.code] = '';
            ele['imagePath_' + item.code] = '';
          });
        });
        this.$forceUpdate();
      }
    },
    // 获取详情数据
    getDetailsData() {
      let v = this;
      v.vajraDistrictList = [];
      v.axios.get(api.get_ymsAdvertisement_detail + `${v.ymsAdvertisementId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.ymsAdvertisementDetailBos;
          v.advertisementTitle = data.advertisementTitle;
          if (list.length > 0) {
            list.map((item, index) => {
              let obj = {
                jumpTargetType: item.jumpTargetType,
                jumpTargetValue: item.jumpTargetValue,
                jumpTargetName: item.jumpTargetName || ''
              };
              let keylist = ['imagePath', 'name'];
              let obj1 = v.handleMultilingualFormFields(item, keylist);
              v.vajraDistrictList.push(Object.assign({}, obj, obj1));
            });
            v.$forceUpdate();
          }
        }
      });
    },
    // 上传图片成功
    handelUploadSuccess(response, item, index) {
      let v = this;
      if (response.code === 0) {
        let url = response.datas[0];
        v.$set(v.vajraDistrictList[index], 'imagePath_' + item.code, url);
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005038'));
        v.$forceUpdate();
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005039'));
      }
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 更换活动
    replaceBtn(item, index) {
      this.currentIndex = index;
      this.$refs['clickJump'].initFun(item);
    },
    // 取消按钮
    rotationChartCancelBtn() {
      this.$router.push('/advertisingManage');
    },
    // 保存按钮
    rotationChartBtn() {
      let v = this;
      let url = '';
      let method = '';
      let query = {
        advertisementTitle: v.advertisementTitle,
        orientationType: 4,
        status: 1, // 默认启用
        ymsAdvertisementDetailBos: []
      };
      if (v.ymsAdvertisementId) {
        url = api.put_ymsAdvertisement_update;
        method = 'put';
        query.ymsAdvertisementId = v.ymsAdvertisementId;
      } else {
        url = api.post_ymsAdvertisement_save;
        method = 'post';
      }
      let newList = [];
      // 校验上传图片、点击跳转活动
      for (let i = 0; i < v.vajraDistrictList.length; i++) {
        let item = v.vajraDistrictList[i];
        let objImg = {};
        let objName = {};
        for (let j = 0; j < v.multilingualNamesList.length; j++) {
          let ele = v.multilingualNamesList[j];
          if (!item['imagePath_' + ele.code] && ele.code === 'zh-CN') {
            v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005032')}${i + 1}${ele.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005033')}`);
            return false;
          }
          if (!item['name_' + ele.code] && ele.code === 'zh-CN') {
            v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005032')}${i + 1}${ele.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005034')}`);
            return false;
          }
          objImg[ele.code] = item['imagePath_' + ele.code] || '';
          objName[ele.code] = item['name_' + ele.code] || '';
          item.imagePath = JSON.stringify(objImg);
          item.name = JSON.stringify(objName);
        }

        if (!item.imagePath) {
          v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005035')}${item.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005036')}`);
          return false;
        }
        if (item.jumpTargetType !== 3) {
          if (!item.jumpTargetValue) {
            v.$Message.warning(`${item.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005037')}`);
            return false;
          }
        }
        newList.push({
          name: item.name,
          imagePath: item.imagePath,
          jumpTargetType: item.jumpTargetType,
          jumpTargetValue: item.jumpTargetValue,
          jumpTargetName: item.jumpTargetName,
          sortNo: i + 1
        });
      }
      query.ymsAdvertisementDetailBos = newList;
      v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.rotationChartCancelBtn();
        }
      });
    },
    // 获取更换活动的设置参数
    updateData(data) {
      let v = this;
      if (data) {
        let jumpTargetType = data.jumpTargetType;
        v.vajraDistrictList.map((item, index) => {
          if (index === v.currentIndex) {
            item.jumpTargetName = data.jumpTargetValue || '';
            // 活动
            if (jumpTargetType === 0) {
              data.activityList.map((ele) => {
                if (ele.ymsActivityPlanId === data.jumpTargetValue) {
                  item.jumpTargetName = ele.activityTitle;
                }
              });
            }
            // 分类
            else if (jumpTargetType === 2) {
              data.ymsProductCategoryList.map((ele) => {
                if (ele.ymsProductCategoryId === data.jumpTargetValue) {
                  item.jumpTargetName = ele.title;
                }
              });
            }

            item.jumpTargetType = data.jumpTargetType;
            item.jumpTargetValue = data.jumpTargetValue;
          }
        });
        v.$forceUpdate();
      }
    }
  },
  components: {
    languagesTabs,
    clickJumpModal
  }
};
</script>

<style lang="less" scoped>
.vajraDistrict_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .vajraDistrict_item {
    width: 19%;

    .jump_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      top: 2px;

      .jump_text {
        display: inline-block;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 145px;
        font-size: 12px;
      }

      .not_filled_text {
        font-size: 12px;
        display: inline-block;
        color: #d00707;
      }
    }

    .upload_txt {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .tips_txt {
        color: #d00707;
        font-size: 12px;
      }
    }

    .img_style {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 60px;
      max-height: 60px;
      min-height: 60px;
    }
  }
}

.vajraDistrict_effect_box {
  width: 644px;
  height: 128px;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 17px 42px 20px 42px;
  display: flex;
  margin-bottom: 60px;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1500);

  .vajraDistrict_effect_item {
    width: 60px;
    cursor: pointer;
    margin-right: 65px;
    text-align: center;

    .banner_img {
      width: 60px;
      height: 60px;
      display: inline-block;
    }

    .design_sketch_styles {
      background-color: #F7F7F7;
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      font-size: 12px;
    }

    .title {
      width: 100%;
      color: #333;
      font-size: 12px;
      font-weight: bold;
      margin-top: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .vajraDistrict_effect_item:last-child {
    margin-right: 0;
  }
}

.options_content {
  box-shadow: 0px -3px 10px 0px #c9cbce;
  position: fixed;
  min-width: 100%;
  z-index: 10;
  background-color: #fff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 15px;
}
</style>